import { useQuery } from "react-query";
import { getAlarmTypeList } from "../../../../../actions/Utilities/AlarmType";

export default function useGetAlarmTypeList () {
  return useQuery("GetAlarmType",getAlarmTypeList, {
    refetchOnWindowFocus: false,
  });
}